module.exports = __webpack_public_path__ + "static/media/img1-1.3a7310ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/nutricheck_foliar/FE/img1-1.png
// module id = 1042
// module chunks = 3